import {
  Box,
  Button,
  NewModal
} from '@platform/ui-library';
import { FC } from 'react';
import {
  useAsync,
  useDesign,
  useServices
} from '../../hooks';
import { WorkflowPromptSubmission } from '../../types';
import { formatDateTime } from '../../utilities';
import LoadingSpinner from '../../widgets/components/LoadingSpinner';
import { Table } from '../table';
import styles from './workflow-prompt-statuses.module.scss';

export type WorkflowPromptStatusesProps = {
  isOpen: boolean;
  onComplete: () => void;
}

export const WorkflowPromptStatuses: FC<WorkflowPromptStatusesProps> = ({
  isOpen,
  onComplete
}) => {
  const { workflowService } = useServices();
  const serialized = useDesign();
  const [statuses, isLoading, error] = useAsync(() => {
    return (!isOpen) ? [] : (
      workflowService.getPromptSubmissions(serialized)
    );
  }, [isOpen, serialized]);
  const content = (() => {
    if (isLoading) {
      return (
        <LoadingSpinner message="Loading..." />
      );
    } else if (typeof error === 'string') {
      return error;
    } else if (error instanceof Error) {
      return error.message;
    } else if (!statuses) {
      return 'Fetching statuses failed.';
    } else if (!statuses.length) {
      return 'No recent submissions found';
    }

    return (
      <Table
        className={styles.table}
        data={statuses.map(({
          activatedOn,
          author,
          message,
          status,
          version
        }: WorkflowPromptSubmission) => {
          return {
            Version: version,
            Status: status ?? 'Not Submitted',
            Author: author,
            'Activated On': (!activatedOn) ? '' : formatDateTime(activatedOn),
            Message: message
          };
        })}
      />
    );
  })();

  return (
    <NewModal className="ui-box-medium" isOpen={isOpen}>
      <Box theme="noPadding">
        <div className="box header">
          <h2>WFS Prompt Submissions</h2>
        </div>
        <div className="box content">
          {content}
        </div>
        <div className="box footer">
          <Button onClick={onComplete}>
            Close
          </Button>
        </div>
      </Box>
    </NewModal>
  );
};
